/* ═══════════════════════════════════════════════════════════════════════
   uwelle® · ficha editorial · ampliar la galería y silenciar el video
   17 sep 2026 · marca de montaje renombrada el 18 sep

   Dos trabajos, los dos sueltos de `uwelle-ficha.js` a propósito: si este
   archivo no carga, la galería sigue funcionando exactamente como hoy y lo
   único que se pierde es la ampliación.

   1 · AMPLIAR. Un solo <dialog> para toda la página, creado la primera vez
       que alguien amplía. Se abre desde la lupa o desde la propia imagen,
       se recorre con las flechas y se cierra con Esc, con el aspa o
       tocando cualquier punto que no sea la imagen. Si el navegador no
       trae <dialog> modal, las lupas se retiran y no queda ningún botón
       que no haga nada.

       EL CIERRE VA DELEGADO. Antes se comparaba `e.target === dialogo`,
       que sólo es cierto cuando el clic cae en el fondo desnudo: el marco
       centrado ocupa el ancho completo, así que los costados —que se ven
       como fondo— caían sobre el marco y el primer clic no cerraba nada.
       Ahora cierra todo lo que no sea la imagen o una flecha, que es lo
       que espera quien está mirando.

       LA MARCA DE MONTAJE NO PUEDE LLAMARSE COMO LAS LUPAS. Se guarda en
       la sección para que una segunda pasada —el editor de temas vuelve a
       emitir `section:load`— no deje dos oyentes sobre el mismo botón. La
       primera versión la escribió en `data-uw-zoom`, el mismo atributo con
       el que se reconocen las lupas: quedaba un octavo elemento
       respondiendo a `[data-uw-zoom]` que no era ninguna lupa sino la
       ficha entera. No llegaba a romper nada porque `querySelectorAll`
       nunca devuelve el nodo sobre el que se consulta, pero es una trampa
       puesta para quien lea esto dentro de seis meses. Ahora se llama
       `data-uw-zoom-listo`, que dice otra cosa y no cruza con nada.

   2 · SILENCIAR. Las vistas que no se ven llevan el atributo `hidden`. Un
       video que se queda sonando detrás de una foto es el defecto clásico
       de las galerías por pestañas, así que se vigila ese atributo y se
       pausa lo que haya dentro.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var SVG_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var SVG_PREV = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var SVG_NEXT = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  var dlg = null;
  var img = null;
  var pie = null;
  var bPrev = null;
  var bNext = null;
  var lista = [];
  var pos = 0;

  function dos(k) {
    return ('0' + k).slice(-2);
  }

  function soporta() {
    var d = document.createElement('dialog');
    return typeof d.showModal === 'function';
  }

  function construir() {
    if (dlg) return dlg;

    dlg = document.createElement('dialog');
    dlg.className = 'uw-zoom';
    dlg.setAttribute('aria-label', 'Imagen ampliada');
    dlg.innerHTML =
      '<div class="uw-zoom__marco">' +
      '<button type="button" class="uw-zoom__x" aria-label="Cerrar">' + SVG_X + '</button>' +
      '<button type="button" class="uw-zoom__nav uw-zoom__nav--prev" aria-label="Imagen anterior">' + SVG_PREV + '</button>' +
      '<img class="uw-zoom__img" alt="">' +
      '<button type="button" class="uw-zoom__nav uw-zoom__nav--next" aria-label="Imagen siguiente">' + SVG_NEXT + '</button>' +
      '</div>' +
      '<p class="uw-zoom__pie"></p>';

    img = dlg.querySelector('.uw-zoom__img');
    pie = dlg.querySelector('.uw-zoom__pie');
    bPrev = dlg.querySelector('.uw-zoom__nav--prev');
    bNext = dlg.querySelector('.uw-zoom__nav--next');

    // Un solo oyente para todo el diálogo. Las flechas navegan, la imagen
    // se queda quieta, y cualquier otro punto —aspa, fondo, costados del
    // marco, el rótulo— cierra al primer clic.
    dlg.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest && t.closest('.uw-zoom__nav')) {
        mover(t.closest('.uw-zoom__nav--prev') ? -1 : 1);
        return;
      }
      if (t.closest && t.closest('.uw-zoom__img')) return;
      cerrar();
    });

    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); mover(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); mover(1); }
    });

    document.body.appendChild(dlg);
    return dlg;
  }

  function pintar() {
    var it = lista[pos];
    if (!it) return;

    img.src = it.src;
    img.alt = it.alt || '';

    // El pie repite el rótulo y el contador de la galería —«EL ENVASE  01/07»—
    // para no perder de vista en qué vista se está mientras se amplía. Se
    // construye con nodos, no con innerHTML: el rótulo viene de un atributo
    // y no tiene por qué pasar por el intérprete de HTML dos veces.
    pie.textContent = '';

    if (it.pie) {
      var rot = document.createElement('span');
      rot.className = 'uw-zoom__rot';
      rot.textContent = it.pie;
      pie.appendChild(rot);
    }

    if (it.total > 1) {
      var num = document.createElement('span');
      num.className = 'uw-zoom__n';
      num.appendChild(document.createTextNode(dos(it.n)));
      var bar = document.createElement('span');
      bar.className = 'nex';
      bar.textContent = '/';
      num.appendChild(bar);
      num.appendChild(document.createTextNode(dos(it.total)));
      pie.appendChild(num);
    }

    pie.hidden = !pie.firstChild;
    bPrev.hidden = lista.length < 2;
    bNext.hidden = lista.length < 2;
  }

  function mover(paso) {
    if (lista.length < 2) return;
    pos = (pos + paso + lista.length) % lista.length;
    pintar();
  }

  function cerrar() {
    if (dlg && dlg.open) dlg.close();
  }

  function abrir(grupo, indice) {
    construir();
    lista = grupo;
    pos = indice;
    pintar();
    if (!dlg.open) dlg.showModal();
  }

  function montar(raiz) {
    // Segunda pasada: el editor de temas vuelve a emitir `section:load` y sin
    // esta marca cada botón acabaría con dos oyentes encima. El nombre es
    // distinto del de las lupas a propósito; ver la cabecera.
    if (raiz.dataset.uwZoomListo) return;

    var lupas = raiz.querySelectorAll('[data-uw-zoom]');
    if (!lupas.length) return;

    raiz.dataset.uwZoomListo = '1';

    if (!soporta()) {
      for (var k = 0; k < lupas.length; k++) lupas[k].remove();
      return;
    }

    var grupo = [];
    for (var i = 0; i < lupas.length; i++) {
      // La numeración no se inventa: se lee del sitio que la manda, que es
      // el orden de las vistas visibles de la galería. Así el contador del
      // pie ampliado y el de la ficha dicen siempre lo mismo, aunque en
      // medio haya un video, que no se amplía y por tanto no trae lupa.
      var fig = lupas[i].closest('.d-slide');
      var hermanas = fig ? fig.parentNode.querySelectorAll('.d-slide') : [];
      var n = 0;
      for (var q = 0; q < hermanas.length; q++) {
        if (hermanas[q] === fig) n = q + 1;
      }

      grupo.push({
        src: lupas[i].getAttribute('data-uw-zoom'),
        alt: lupas[i].getAttribute('data-uw-alt') || '',
        pie: lupas[i].getAttribute('data-uw-pie') || '',
        n: n,
        total: hermanas.length
      });
    }

    for (var j = 0; j < lupas.length; j++) {
      (function (boton, indice) {
        boton.addEventListener('click', function (e) {
          e.preventDefault();
          abrir(grupo, indice);
        });

        // La imagen también amplía: la lupa es el atajo visible y el
        // acceso por teclado, pero nadie busca un botón para tocar la foto.
        var marco = boton.closest('.d-slide__box');
        var foto = marco ? marco.querySelector('img') : null;
        if (foto) {
          foto.addEventListener('click', function () { abrir(grupo, indice); });
        }
      })(lupas[j], j);
    }
  }

  function pausar(figura) {
    var videos = figura.querySelectorAll('video');
    for (var i = 0; i < videos.length; i++) {
      try { videos[i].pause(); } catch (e) {}
    }
    var marcos = figura.querySelectorAll('iframe');
    for (var j = 0; j < marcos.length; j++) {
      try {
        marcos[j].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        marcos[j].contentWindow.postMessage('{"method":"pause"}', '*');
      } catch (e) {}
    }
  }

  function vigilar(raiz) {
    if (raiz.dataset.uwPausaListo) return;

    var figuras = raiz.querySelectorAll('.d-slide');
    if (!figuras.length || typeof MutationObserver !== 'function') return;

    raiz.dataset.uwPausaListo = '1';

    var ojo = new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var nodo = cambios[i].target;
        if (nodo.hasAttribute('hidden')) pausar(nodo);
      }
    });

    for (var k = 0; k < figuras.length; k++) {
      ojo.observe(figuras[k], { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  function arrancar() {
    var fichas = document.querySelectorAll('.uw-ficha');
    for (var i = 0; i < fichas.length; i++) {
      montar(fichas[i]);
      vigilar(fichas[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El editor de temas vuelve a pintar la sección entera al cambiar un
  // ajuste: sin esto, la lupa deja de responder en la vista previa.
  document.addEventListener('shopify:section:load', arrancar);
})();